<template>
    <div class='cl-w-100 cl-pos--fixed'>
        <div class="cl-hidden--mobile pc">
            <div class="logo">
                <div class="cl-pos--relative cl-text--center">
                    <div class="logo_height">
                        <!-- <a href="javascript:;"> -->
                        <a href="/">
                            <img :src="gethome.logo" alt="logo">
                        </a>
                        <div class="cl-display--flex cl-pos--relative" style="float: right;">
                            <ul class="cl-ul cl-display--flex cl-pos--absolute" style="right: 25px; top: 10px;">
                                <!-- member -->
                                <li class="customer_account cl-pd--10">
                                    <div class="dropdown cl-pos--static">
                                        <a class="cl-a" href="/check" data-toggle="dropdown">
                                            <svg class="member-svg qk-text--nav_menu_icon qk-vert--mid"
                                                xmlns="http://www.w3.org/2000/svg" height="24" width="25.8"
                                                viewbox="0 0 24 24" fill="none">
                                                <circle cx="12" cy="6" r="5" stroke="currentColor" stroke-width="2">
                                                </circle>
                                                <path
                                                    d="M17.607 22.9957H6.393C5.54025 23.04 4.70467 22.7442 4.06888 22.1729C3.43309 21.6017 3.0488 20.8015 3 19.9471V19.1174C3 14.6077 7.032 11 12 11C16.968 11 21 14.6077 21 19.1174V19.9471C20.9512 20.8015 20.5669 21.6017 19.9311 22.1729C19.2953 22.7442 18.4598 23.04 17.607 22.9957V22.9957Z"
                                                    stroke="currentColor" stroke-width="2" stroke-miterlimit="10">
                                                </path>
                                            </svg>
                                            <span class="text"></span>
                                        </a>
                                    </div>
                                </li>
                                <li class="cart cl-pd--10">
                                    <!--電腦版的購物車選單-->
                                    <div class="dropdown cl-pos--relative">
                                        <a :href="number != 0 ? '/cart' : '/'" data-toggle="dropdown"
                                            class="shopcart cl-a">
                                            <svg class="cart-svg qk-text--nav_menu_icon qk-vert--mid"
                                                xmlns="http://www.w3.org/2000/svg" height="24" width="32"
                                                viewbox="0 0 24 24" fill="none">
                                                <path d="M1 1H3.86592L7.40731 18H20" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                </path>
                                                <path d="M5 4H23L21.2347 14.0711L7.29582 15" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                </path>
                                                <path d="M11.9199 10.1201H16.2299" stroke="currentColor"
                                                    stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                </path>
                                                <path
                                                    d="M7 23C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21C6.44772 21 6 21.4477 6 22C6 22.5523 6.44772 23 7 23Z"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round"></path>
                                                <path
                                                    d="M20 23C20.5523 23 21 22.5523 21 22C21 21.4477 20.5523 21 20 21C19.4477 21 19 21.4477 19 22C19 22.5523 19.4477 23 20 23Z"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round"></path>
                                            </svg>
                                            <span class="cl-circle cl-pos--absolute shopcart_num">{{ number }}</span>
                                            <span class="global-cart-loading"></span>
                                        </a>
                                    </div>
                                </li>
                                <!-- search -->
                                <li class="search cl-pd--10" id="search-icon">
                                    <div class="dropdown cl-pos--static" @click="open_dialog" ref="toggleButton">
                                        <a href="javascript:void(0)" data-toggle="dropdown" class="cl-a">
                                            <svg class="saerch-svg qk-text--nav_menu_icon qk-vert--mid"
                                                xmlns="http://www.w3.org/2000/svg" height="24" width="26"
                                                viewbox="0 0 24 24">
                                                <path
                                                    d="M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                                                    stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                    stroke-linejoin="round"></path>
                                                <path d="M19 19L23 23" stroke="currentColor" stroke-width="2"
                                                    stroke-linecap="round" stroke-linejoin="round"></path>
                                            </svg>
                                        </a>
                                    </div>
                                    <div :class="showPopup ? 'search_dialog' : 'display_none search_dialog'"
                                        ref="search" @click.stop>
                                        <div class="search_area">
                                            <form @submit.prevent="submitSearch">
                                                <input class="input" type="text" v-model="keyword" placeholder="請輸入關鍵字">
                                                <button style="cursor: pointer;" class="button"
                                                    type="submit">搜尋</button>
                                            </form>
                                        </div>
                                    </div>
                                </li>
                                <!-- express delivery -->
                            </ul>
                        </div>
                        <!-- </a> -->
                    </div>
                </div>
            </div>
            <div class="nav_list">
                <div class="cl-pd_x--15">
                    <div class="">
                        <ul
                            class="cl-ul cl-display--flex  cl-flex--row cl-flex--wrap cl-justify--center cl-align--center">
                            <li class="nav_li" v-for="item in cate" @click="gocate(item)" style="cursor: pointer;">
                                {{ item.cate_name }}
                            </li>
                            <li class="nav_li" v-for="item in getnav" @click="gonav(item)" style="cursor: pointer;">
                                <!-- {{ item.name }} -->
                                <a :href="`/nav/${item.name}`">{{ item.name }}</a>
                            </li>
                            <li v-if="isarticle" class="nav_li" @click="goarticle()" style="cursor: pointer;">
                                文章專欄
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="cl-hidden--pc mobile">
            <div class="cl-pd_x--10">
                <ul class="cl-ul cl-display--flex cl-align--center mob_ul">
                    <li class="haug"><svg @click="opendrawer"
                            class="menu-svg qk-svg--nav_menu_icon qk-cursor--pointer qk-vert--mid"
                            xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 0 50 50">
                            <path d="M51.529,3H1.5C0.672,3,0,2.329,0,1.5S0.672,0,1.5,0h50.029c0.828,0,1.5,0.671,1.5,1.5
                S52.357,3,51.529,3z"></path>
                            <path d="M51.529,24.023H1.5c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5h50.029
                c0.828,0,1.5,0.672,1.5,1.5S52.357,24.023,51.529,24.023z"></path>
                            <path d="M29.101,45.046H1.5c-0.828,0-1.5-0.672-1.5-1.5s0.672-1.5,1.5-1.5h27.601
                c0.828,0,1.5,0.672,1.5,1.5S29.929,45.046,29.101,45.046z"></path>
                        </svg></li>
                    <li class="log_imges">
                        <a href="/">
                            <img :src="gethome.logo" alt="logo">
                        </a>
                    </li>
                    <li class="search">
                        <div class="dropdown">
                            <a href="javascript:void(0)" @click="open_dialog_mb" data-toggle="dropdown" class="cl-a"
                                ref="toggleButton_mb">
                                <svg class="saerch-svg qk-text--nav_menu_icon qk-vert--mid"
                                    xmlns="http://www.w3.org/2000/svg" height="24" width="26" viewbox="0 0 24 24"
                                    fill="none">
                                    <path
                                        d="M21 11C21 16.5228 16.5228 21 11 21C5.47715 21 1 16.5228 1 11C1 5.47715 5.47715 1 11 1C16.5228 1 21 5.47715 21 11Z"
                                        stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round">
                                    </path>
                                    <path d="M19 19L23 23" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"></path>
                                </svg>
                            </a>
                        </div>
                        <div :class="showPopup_mb ? 'search_dialog' : 'display_none search_dialog'" ref="search_mb"
                            @click.stop>
                            <div class="search_area">
                                <form @submit.prevent="submitSearch">
                                    <input class="input" type="text" v-model="keyword" placeholder="請輸入關鍵字">
                                    <button style="cursor: pointer;" class="button" type="submit">搜尋</button>
                                </form>
                            </div>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <el-drawer class="drawer_nav" :visible.sync="drawer" @close="drawer_close" direction="ltr" size="70%">
            <div class="title">
                <a href="/">
                    <img :src="gethome.logo" alt="logo">
                </a>
                <button @click="btn_close">

                </button>
            </div>
            <div class="content">
                <div class="content_title">主選單</div>
                <ul class="cl-ul">
                    <li v-for="item in cate" @click="gocate(item)" style="cursor: pointer;">
                        {{ item.cate_name }}
                    </li>
                    <li v-for="item in getnav" @click="gonav(item)" style="cursor: pointer;">
                        <!-- {{ item.name }} -->
                        <a :href="`/nav/${item.name}`">{{ item.name }}</a>
                    </li>
                    <li v-if="isarticle" class="nav_li" @click="goarticle()" style="cursor: pointer;">
                        文章專欄
                    </li>
                </ul>
            </div>
        </el-drawer>
    </div>
</template>
<script>
import Vue from 'vue';
import { Drawer } from 'element-ui';
import { mapState } from 'vuex';
import FacebookEventApi from '@/js/FacebookEventApi'
Vue.use(Drawer);
export default {
    components: {},
    data() {
        return {
            showPopup: false,
            showPopup_mb: false,
            drawer: false,
            keyword: ''
        };
    },
    computed: {
        ...mapState('header', ['cate', 'getfb', 'getnav', 'gethome', 'isarticle']),
        ...mapState('cart', ['number']),
    },
    watch: {},
    methods: {
        handleOutsideClick(event) {
            // 检查点击是否发生在弹出框外部
            if (this.$refs.search && !this.$refs.search.contains(event.target) && (this.$refs.toggleButton && !this.$refs.toggleButton.contains(event.target))
            ) {
                this.showPopup = false;
            }
            if (this.$refs.search_mb && !this.$refs.search_mb.contains(event.target) && (this.$refs.toggleButton_mb && !this.$refs.toggleButton_mb.contains(event.target))
            ) {
                this.showPopup_mb = false;
            }
        },
        open_dialog() {
            // console.log(1);
            // 执行某些操作
            this.showPopup = !this.showPopup;
            // console.log("Button inside popup clicked!");
        },
        open_dialog_mb() {
            // console.log(1);
            // 执行某些操作
            this.showPopup_mb = !this.showPopup_mb;
            // console.log("Button inside popup clicked!");
        },
        btn_close() {
            this.drawer = !this.drawer;
        },
        drawer_close() {
            var navHeader = document.getElementById('header');
            navHeader.classList.add('cl-pos--fixed');
            navHeader.style.zIndex = '1001';
            var navHeaderHeight = document.getElementById('header').offsetHeight;
            document.getElementById('router_viewbody').style.paddingTop = navHeaderHeight + 'px';
        },
        opendrawer() {
            this.drawer = !this.drawer;
            var navHeader = document.getElementById('header');
            navHeader.classList.remove('cl-pos--fixed');
            document.getElementById('router_viewbody').style.paddingTop = '0px';
            navHeader.style.zIndex = 'auto';
        },
        // 前往商品组
        gocate(item) {
            // console.log(item.cate_name,item.cid);
            this.drawer = false;
            this.$router.push({
                path: `/categroy/${item.cate_name}/${item.cid}`,
            });

            this.$store.dispatch('commodity/getclassification', item.cid).then(e => {
                // this.list = e.data;
            })
        },
        submitSearch() {
            // 使用编程式导航进行路由跳转
            this.$store.dispatch('commodity/getsearch', this.keyword).then(e => {
                // this.list = e.data;
                this.$router.push(`/search/${this.keyword}`);
            })
        },
        //前往文章专栏
        goarticle(e) {
            this.drawer = false;
            this.$router.push({
                path: `/article`,
            }).catch(err => {

            })
        },
    },
    created() {
    },

    mounted() {
        document.addEventListener("click", this.handleOutsideClick);
        this.$store.dispatch('header/getwebsite').then(e => {
        });
        this.$store.dispatch("header/get").then(e => {
        });
        this.$store.dispatch("header/getfb").then(e => {
            var myFacebookEventApi = new FacebookEventApi(this.getfb.ShenV1FbPixel1, this.getfb.ShenV1FbPixel1_hash);
            var fb_em = myFacebookEventApi.fbgetCookie('em');
            var fb_phone = myFacebookEventApi.fbgetCookie('phone');
            var fb_fn = myFacebookEventApi.fbgetCookie('fn');
            var fb_external_id = myFacebookEventApi.fbgetCookie('external_id');
            var fb_fbclid = myFacebookEventApi.fbgetCookie('fbclid');
            myFacebookEventApi.callPageView(fb_em, fb_phone, fb_fn, fb_external_id, fb_fbclid);
        });
        // this.$store.dispatch("header/getnav").then(e => {
        //     // console.log('nav');
        //   // console.log(e);
        // });
        this.$store.dispatch('cart/get').then(() => {
        });
    },
    beforeDestroy() {
        // 移除全局点击事件监听
        document.removeEventListener("click", this.handleOutsideClick);
    },
}
</script>
<style src="./index.scss" lang='scss' scoped></style>